import styled from 'styled-components';

interface ContainerProps {
  margin?: string;
}

export const HostSection = styled.section`
  max-width: 100%;
  margin: 0 auto 2rem;
  max-width: 120rem;
  background-color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.xxxlarge};
  width: 100%;
`;

export const Container = styled.div<ContainerProps>`
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
`;
export const Title = styled.p`
  font-size: 22px;
  font-weight: 600;
  color: #222;
  margin-bottom: 24px;
`;
export const Content = styled.div`
  display: flex;
`;
export const ContentLeft = styled.div`
  flex: 1;
`;
export const HostImg = styled.span`
  margin-left: 60px;
`;
export const HostList = styled.ul`
  display: flex;
  margin-bottom: 20px;
  li {
    display: flex;
    align-items: center;
    margin-right: 20px;
    font-size: 14px;
    line-height: 18px;
    color: #222;
  }
`;

export const HostBioWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 1.6rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #222;

  a {
    color: #2274e0;
  }
`;

export const HostBio = styled.p`
  max-width: 100%;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Responsibilities = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #222;
  margin-bottom: 16px;
  span {
    font-weight: 600;
  }
  > div {
    display:flex
    align-items: center
  }
`;
export const HostFooter = styled.div`
  display: flex;
  align-items: center;
`;
export const SmallText = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: #222;
  margin-left: 10px;
`;
export const CtaButton = styled.button`
  font-family: 'Rubik';
  border: 1px #2276e3 solid;
  height: 44px;
  padding: 0 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #2276e3;
  cursor: pointer;
  outline: 0;
  background: none;
  border-radius: 8px;
`;
